import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import { patientTab } from "../../components/Datas";
import { Link, useParams } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import MedicalRecord from "./MedicalRecord";
import AppointmentsUsed from "../../components/UsedComp/AppointmentsUsed";
import InvoiceUsed from "../../components/UsedComp/InvoiceUsed";
import PaymentsUsed from "../../components/UsedComp/PaymentUsed";
import PersonalInfo from "../../components/UsedComp/PersonalInfo";
import PatientImages from "./PatientImages";
import HealthInfomation from "./HealthInfomation";
import DentalChart from "./DentalChart";
import staffApi from "../../api/staff/staff.api";
import toast from "react-hot-toast";
import Loading from "../../Util/Loading";
import bookingApi from "../../api/booking/BookingApi";
import UpcomingAppointments from "../Dashboad/UpcomingApointment";
import Customers from "../../components/StaffModal/Customers";
import StaffInfo from "../../components/StaffModal/StaffInfo";
import TodayAppointments from "../Dashboad/TodayAppintment";

function StaffProfile() {
  const { id } = useParams();

  const [staff, setStaff] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [staffBooking, setStaffBooking] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getStaffInfo(), getBookingByStaffId()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const getStaffInfo = async () => {
    try {
      const { response, err } = await staffApi.getStaffInfo(id);

      if (response && response.data) {
        setStaff(response.data.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  // console.log({ staff });

  const getBookingByStaffId = async () => {
    try {
      const { response, err } = await bookingApi.getBookingByStaffId({ id });

      if (response?.data?.data) {
        setStaffBooking(response.data.data);
      } else {
        toast.error("No bookings found for this staff");
      }
    } catch (error) {
      toast.error("Failed to fetch bookings");
      console.error("Error fetching bookings:", error);
    }
  };

  // console.log({ staff });

  // console.log({ staffBooking });

  const [activeTab, setActiveTab] = React.useState(1);

  const tabPanel = () => {
    switch (activeTab) {
      case 1:
        return <TodayAppointments bookings={staffBooking} />;

      case 2:
        return <UpcomingAppointments bookings={staffBooking} />;
      case 3:
        return <AppointmentsUsed doctor={staffBooking} />;
      case 4:
        return <Customers doctor={staffBooking} />;
      case 5:
        return staff ? <StaffInfo staff={staff} titles={false} /> : <Loading />;

      case 6:
        return <InvoiceUsed />;
      case 7:
        return <PatientImages />;
      case 8:
        return <HealthInfomation />;
      default:
        return;
    }
  };

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Layout>
      <div className="flex items-center gap-4 ">
        <Link
          to="/staffs"
          className="bg-dry border border-border border-dashed text-redlight rounded-lg py-3 px-4 text-md"
        >
          <IoArrowBackOutline />
        </Link>
        <h1 className="text-md font-semibold text-textGray">{staff?.name}</h1>
      </div>
      <div className=" grid grid-cols-12 gap-6 my-8 items-start min-h-screen">
        <div
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-delay="100"
          data-aos-offset="200"
          className="col-span-12 flex-colo gap-6 lg:col-span-4 bg-dry rounded-xl  p-6 lg:sticky top-28"
        >
          <img
            src={staff?.photo}
            alt="setting"
            className="w-40 h-40 rounded-full object-cover border  border-border"
          />
          <div className="gap-2 flex-colo">
            <h2 className="text-sm font-semibold text-redlight">
              {staff?.name}
            </h2>
            <p className="text-xs text-textGray">{staff?.email}</p>
            {/* <p className="text-xs text-textGray">+64 {staff?.phone}</p> */}
          </div>
          {/* tabs */}
          <div className="flex-colo gap-3 px-2 xl:px-12 w-full">
            {patientTab.map((tab, index) => (
              <button
                onClick={() => setActiveTab(tab.id)}
                key={index}
                className={`
                ${
                  activeTab === tab.id
                    ? "bg-drylight text-redlight border border-border"
                    : "bg-dry text-redlight hover:bg-drylight hover:text-redlight"
                }
                text-xs gap-4 flex items-center w-full p-4 rounded-xl`}
              >
                <tab.icon className="text-lg" /> {tab.title}
              </button>
            ))}
          </div>
        </div>
        {/* tab panel */}
        <div
          // data-aos="fade-left"
          // data-aos-duration="1000"
          // data-aos-delay="100"
          // data-aos-offset="200"
          className="col-span-12 lg:col-span-8 bg-dry rounded-xl border-[1px] border-border p-6"
        >
          {tabPanel()}
        </div>
      </div>
    </Layout>
  );
}

export default StaffProfile;
